<template>
    <el-select-v2
        v-model="value"
        filterable
        remote
        :remote-method="remoteMethod"
        clearable
        :options="options"
        :loading="loading"
        placeholder="Search Here"
        style="width: 100%"

    />
</template>

<script>
import {
    ElSelectV2
} from 'element-plus'
export default {
    name: "AirportSearch",
    components: {    ElSelectV2 },

    data() {
        return {
            loading: false,
            value:'',
            options:[]
        }
    },
    methods: {
        remoteMethod(string) {
            let currentObj = this;
            currentObj.loading=true;
            axios.post('/searchairport', {key:string}).then(function (response) {
                currentObj.options=response.data.data;
                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        }
    }
}
</script>

<style scoped>

</style>
